module.exports = __webpack_public_path__ + "doctor_10.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/llc/doctors/doctor_10.jpg
// module id = 886
// module chunks = 0